export default "/kiban/_next/static/images/01_1L_alm_base-d03581b2d55c50ea742a6d28f2f23c0b.png";